/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type RenewalWorkflowStepDto = {
    status: RenewalWorkflowStepDto.status;
    label: string;
    description: string;
    completedAt?: string | null;
    triggeredBy?: string | null;
};
export namespace RenewalWorkflowStepDto {
    export enum status {
        PENDING = 'PENDING',
        AWAITING_CLIENT_RESPONSE = 'AWAITING_CLIENT_RESPONSE',
        CONFIRMED_NO_CHANGE = 'CONFIRMED_NO_CHANGE',
        REQUEST_CALLBACK = 'REQUEST_CALLBACK',
        PENDING_AMENDMENTS = 'PENDING_AMENDMENTS',
        AWAITING_UPDATED_PRICING = 'AWAITING_UPDATED_PRICING',
        UPDATED_TERMS_RECEIVED = 'UPDATED_TERMS_RECEIVED',
        PRICING_FINALISED = 'PRICING_FINALISED',
        SENT_TO_CLIENT = 'SENT_TO_CLIENT',
        AWAITING_PAYMENT = 'AWAITING_PAYMENT',
        RENEWED_SUCCESSFULLY = 'RENEWED_SUCCESSFULLY',
        LAPSED = 'LAPSED',
        LOST = 'LOST',
        INSURER_REVIEW = 'INSURER_REVIEW',
    }
}

